module.exports = __webpack_public_path__ + "assets/img/pro_4.deccbc69.png";